import React from 'react';

const FinancialStatusIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <circle cx="16" cy="16" r="12" fill="#F5C518"/>
        <circle cx="16" cy="16" r="12" fill="url(#financialCoinShine)"/>
        <circle cx="16" cy="16" r="9" fill="none" stroke="#c9a012" strokeWidth="1" opacity="0.5"/>
        <text x="16" y="21" textAnchor="middle" fontSize="13" fontWeight="700" fill="#c9a012" fontFamily="Sora, sans-serif">$</text>
        <circle cx="24" cy="7" r="1.3" fill="#66BB6A"/>
        <circle cx="27" cy="12" r="0.9" fill="#F5C518" opacity="0.6"/>
        <defs>
            <radialGradient id="financialCoinShine" cx="35%" cy="30%" r="70%">
                <stop offset="0" stopColor="#fff" stopOpacity="0.45"/>
                <stop offset="0.5" stopColor="#fff" stopOpacity="0.05"/>
                <stop offset="1" stopColor="#000" stopOpacity="0.08"/>
            </radialGradient>
        </defs>
    </svg>
);

export default FinancialStatusIcon;